import {
  useProductBase,
  useProductVariant,
  useVariantMissingDimensions,
  useProductOptions,
  useProductVariants,
  getVariantFromOptions,
} from "@made-people/grease-product";
import { useTranslate } from "@made-people/grease-translations";
import { getStockStatus } from "./out-of-stock-information";
import { getProductDiscontinuedStatus } from "./get-stock-delivery-data";
import { useAllocationRule } from "../../../services/centra/allocation-rule/mm-allocation-rule-provider";
import { ProductDeliveryStatus } from "./product-delivery-status";
import { WAREHOUSE_NAMES } from "../../../services/centra/allocation-rule/constants";
import { buildStockByWarehouse } from "./build-stock-by-warehouse";

export const WithVariantsProductDeliveryStatus = () => {
  const productBase = useProductBase();
  const translate = useTranslate();
  const variant = useProductVariant();
  const missingDimensions = useVariantMissingDimensions();
  const { selectedOptions } = useProductOptions();
  const variants = useProductVariants();
  const {
    allocationRule,
    isLoading: isAllocationRuleLoading,
    hasError: isAllocationRuleError,
  } = useAllocationRule();

  const discontinued = getProductDiscontinuedStatus(productBase);

  if (isAllocationRuleLoading || isAllocationRuleError) {
    return <div className="min-h-5" />;
  }

  const hasMatchingVariant =
    missingDimensions.length > 0 ||
    getVariantFromOptions(variants, selectedOptions) !== undefined;

  if (missingDimensions.length) {
    return <div className="min-h-5" />;
  }

  if (!hasMatchingVariant) {
    return (
      <ProductDeliveryStatus
        discontinued={discontinued}
        status={translate("Delivery_Invalid_Size_Combination")}
        inStock={false}
        isImmediateDelivery={false}
      />
    );
  }

  if (variant.additionalInventory.length === 0) {
    return <div className="min-h-5" />;
  }

  const warehouses = allocationRule?.warehouses ?? [];
  const warehouseIds = warehouses.map((w) => String(w.id));
  const virtualWarehouseId = warehouses.find(
    (w) => w.name === WAREHOUSE_NAMES.VIRTUAL,
  )?.id;
  const stockByWarehouse = buildStockByWarehouse(variant.additionalInventory);

  const { deliveryStatus, isImmediateDelivery } = getStockStatus(
    {
      discontinued,
      warehouseIds,
      virtualWarehouseId:
        virtualWarehouseId !== undefined
          ? String(virtualWarehouseId)
          : undefined,
      stockByWarehouse,
    },
    translate,
  );

  const realWarehouseIds = virtualWarehouseId
    ? warehouseIds.filter((id) => id !== String(virtualWarehouseId))
    : warehouseIds;
  const hasStock = realWarehouseIds.some(
    (id) => (stockByWarehouse[id] ?? 0) > 0,
  );

  return (
    <ProductDeliveryStatus
      discontinued={discontinued}
      status={deliveryStatus}
      inStock={hasStock}
      isImmediateDelivery={isImmediateDelivery}
    />
  );
};
